import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "as", "pageType", "slug", "url"];
import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { DROPDOWN_DIRECTION_LEFT, DROPDOWN_DIRECTION_OPTIONS, DROPDOWN_DIRECTION_RIGHT } from './DropdownMenu.constants';
import BaseLink from '../../../../../../atoms/Link';
import useResponsive from '../../../../../../hooks/use-responsive/use-responsive';
import { isExternalPage } from '../../../../../../services/pages';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../../services/proptypes';
import FishermanIcon from '../../../../../foundation/components/Icon';
import { cleanLinkProps, sortLinks } from '../../../../services/links';
import { DEFAULT_LINK_AS } from '../Link/Link.constants';
import './DropdownMenu.less';
var defaultProps = {
  linksAs: DEFAULT_LINK_AS,
  className: '',
  dropdownDirection: DROPDOWN_DIRECTION_RIGHT
};
function DropdownMenu(_ref) {
  var title = _ref.title,
    options = _ref.options,
    linksAs = _ref.linksAs,
    className = _ref.className,
    dropdownDirection = _ref.dropdownDirection;
  var sortedOptions = sortLinks(options);
  var cleanedOptions = cleanLinkProps(sortedOptions);
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile,
    isTablet = _useResponsive.isTablet;
  var dropdownDirectionClass = dropdownDirection === DROPDOWN_DIRECTION_LEFT ? 'dropdown-direction-left' : '';
  var iconName = isMobile || isTablet ? 'chevron-right' : 'angle-down';
  return /*#__PURE__*/React.createElement(Dropdown, {
    floating: !!isMobile,
    item: true,
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "divider text"
    }, title),
    className: "dropdown-menu",
    icon: /*#__PURE__*/React.createElement(FishermanIcon, {
      iconName: iconName
    }),
    "aria-label": "dropdown-menu-links"
  }, /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: dropdownDirectionClass
  }, cleanedOptions.map(function (_ref2) {
    var linkTitle = _ref2.title,
      as = _ref2.as,
      pageType = _ref2.pageType,
      slug = _ref2.slug,
      url = _ref2.url,
      rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
      key: linkTitle,
      as: BaseLink,
      to: isExternalPage(pageType) ? url : slug,
      linksAs: as || linksAs,
      title: linkTitle,
      className: className,
      internal: !isExternalPage(pageType),
      role: "option"
    }, rest));
  })));
}
DropdownMenu.defaultProps = defaultProps;
export default DropdownMenu;